module.exports = __webpack_public_path__ + "static/media/21ECLAC16.bf52c6c0.jpg";